// NATIVE

// INSTALLED

// CUSTOM
import { AxiosAdapter } from '../commons/adapters';

const http = new AxiosAdapter();

export const getAreasService = async () => {
  try {
    return await http.get<any>('/v1/area');
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('getAreasService ', error);
  }
};

export const createAreaService = async (area: object, setPercentajeCCompany: any) => {
  try {
    return await http.post<any>('/v1/area', area, setPercentajeCCompany);
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('createAreaService ', error);
  }
};

export const getAreaDetailService = async (areaId: string) => {
  try {
    return await http.get<any>(`/v1/area/${areaId}`);
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('getAreaDetailService ', error);
  }
};

export const getAreaEditService = async (areaId: string) => {
  try {
    return await http.get<any>(`/v1/area/${areaId}/edit`);
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('getAreaDetailService ', error);
  }
};

export const updateAreaDetailService = async (area: object) => {
  try {
    return await http.put<any>(`/v1/area`, area);
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('updateAreaDetailService ', error);
  }
};

export const desactiveAreaService = async (areaId: string) => {
  try {
    return await http.delete<any>(`/v1/area/${areaId}`);
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('desactiveAreaService ', error);
  }
};

export const activeAreaService = async (areaId: string) => {
  try {
    return await http.patch<any>(`/v1/area/${areaId}`);
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('activeAreaService ', error);
  }
};

export const getAreasByPaginateService = async (page: number) => {
  try {
    return await http.get<any>(`/v1/area?page=${page}&take=10`);
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('getAreasByPaginateService ', error);
  }
};
